import React, { useState, useEffect, useRef } from 'react';
import { ZoomIn, ImageOff } from 'lucide-react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import EuroPallet from '../../assets/images/europallet.png';
import CP1 from '../../assets/images/CP1.png';
import CP2 from '../../assets/images/CP2.png';
import CP3 from '../../assets/images/CP3.png';
import CP4 from '../../assets/images/CP4.png';
import CP5 from '../../assets/images/CP5.png';
import CP6 from '../../assets/images/CP6.png';
import CP7 from '../../assets/images/CP7.png';
import CP8 from '../../assets/images/CP8.png';
import CP9 from '../../assets/images/CP9.png';

import Bookbox from '../../assets/images/bookbox.jpg';
import WrapNGoBox from '../../assets/images/WrapNGo.jpg';
import UNBox from '../../assets/images/UN-Box.png';
import C495L from '../../assets/images/p56125101.jpg';
import C1310 from '../../assets/images/bigbrummy.png';
import C990 from '../../assets/images/middlebrummy.png';
import C870 from '../../assets/images/p34347101.jpg';
import KBox from '../../assets/images/KBox.png';
import LBox from '../../assets/images/LBox.png';
import UBox from '../../assets/images/ubox.png';
import HalfUBox from '../../assets/images/halfubox.png';
import VariBox from '../../assets/images/VariBox.png';
import AmericanPallet from '../../assets/images/americanpallet.png';
import SinglePallet from '../../assets/images/singlepallet.png';
import WBox from '../../assets/images/00049521-02.png';
import PBox from '../../assets/images/00049522-02.png';
import HalfEURO from '../../assets/images/00082993.png';
//import SmallBrummy from '../../assets/images/7344756d.jpg';

const OuterboxBarcodeTable = () => {
  const [copiedCode, setCopiedCode] = useState(null);
  const barcodeRefs = useRef({});

  const outerboxData = [
    { value: "EURO", label: "EURO", code: "00083091.00", volume: "", weight: "15", length: "120", width: "80", height: "15", image: EuroPallet },  
    { value: "CP1", label: "CP1", code: "14001U", volume: "", weight: "20", length: "120", width: "100", height: "138", image: CP1 },
    { value: "CP2", label: "CP2", code: "14002U", volume: "", weight: "20", length: "120", width: "80", height: "138", image: CP2 },   
    { value: "CP3", label: "CP3", code: "P329583.01", volume: "2.05", weight: "18", length: "115", width: "115", height: "15", image: CP3 },
    { value: "CP4", label: "CP4", code: "14004U", volume: "", weight: "20", length: "130", width: "110", height: "138", image: CP4 },
    { value: "CP5", label: "CP5", code: "14005U", volume: "", weight: "20", length: "114", width: "76", height: "138", image: CP5 }, 
    { value: "CP6", label: "CP6", code: "14006U", volume: "", weight: "20", length: "120", width: "100", height: "156", image: CP6 },
    { value: "CP7", label: "CP7", code: "14007U", volume: "", weight: "20", length: "130", width: "110", height: "156", image: CP7 },
    { value: "CP8", label: "CP8", code: "15001HT", volume: "", weight: "22", length: "114", width: "114", height: "156", image: CP8 },   
    { value: "CP9", label: "CP9", code: "14009U", volume: "", weight: "22", length: "114", width: "114", height: "156", image: CP9 },
    { value: "AmericanPallet", label: "American Pallet", code: "", volume: "1.493", weight: "20", length: "122", width: "102", height: "12", image: AmericanPallet },
    { value: "SinglePallet", label: "Single Pallet", code: "", volume: "", weight: "13", length: "120", width: "80", height: "12", image: SinglePallet }, 
    { value: "Bookbox", label: "Book-box", code: "00073953.00", volume: "", weight: "0.2", length: "36.5", width: "26.5", height: "", image: Bookbox },
    { value: "WrapNGoBox", label: "WrapNGo-box", code: "00064299.00", volume: "0.003", weight: "0.2", length: "35", width: "16", height: "5", image: WrapNGoBox },
    { value: "VariBox", label: "Vari-box", code: "00073962.00", volume: "", weight: "0.5", length: "38", width: "31", height: "", image: VariBox },
    { value: "1/2E-H", label: "1/2Euro High with pallet", code: "00062602.01", volume: "0.373", weight: "11.39", length: "80", width: "62", height: "76", },
    { value: "1/2E-L", label: "1/2Euro Low with pallet", code: "00082994.00", volume: "0.269", weight: "10.713", length: "79.5", width: "59.5", height: "54.5" },
//    { value: "HalfEuro", label: "1/2Euro", code: "00082993.00", volume: "", weight: "", length: "", width: "", height: "74". image: HalfEURO },    
    { value: "1/2U", label: "1/2 U-box", code: "7336406.D", volume: "0.017", weight: "", length: "37.5", width: "23.7", height: "19", image: HalfUBox },
    { value: "UNBox", label: "UN-box", code: "7344736.B", volume: "0.036", weight: "1.285", length: "48", width: "38", height: "20", image: UNBox },
    { value: "PBox", label: "P-box", code: "00049522.02", volume: "0.023", weight: "0.62", length: "47,5", width: "37,5", height: "13", image: PBox },
    { value: "LBox", label: "L-box", code: "00081189.00", volume: "0.064", weight: "0.92", length: "47", width: "33", height: "41", image: LBox },
    { value: "KBox", label: "K-box", code: "7344732.C", volume: "0.114", weight: "2", length: "47", width: "37.5", height: "64" , image: KBox },  
    { value: "UBox", label: "U-box", code: "7344736.B", volume: "0.036", weight: "1.285", length: "48", width: "38", height: "20", image: UBox },
    { value: "C760", label: "C760-Kleine/small Brummy", code: "7344756.C", volume: "0.271", weight: "10", length: "76", width: "49.5", height: "72" },
    { value: "C990", label: "C990-Middle Brummy", code: "7346198.C", volume: "0.557", weight: "19", length: "99", width: "76", height: "74", image: C990 },
    { value: "C1310", label: "C1310-Big Brummy", code: "7344768.C", volume: "0.737", weight: "28", length: "131", width: "76", height: "74", image: C1310 },
    { value: "C495L", label: "C495L", code: "P561251.01", volume: "0.098", weight: "2.3", length: "74.9", width: "48.4", height: "31.5", image: C495L },
    { value: "TSGA/TSGB", label: "TSGA/TSGB", code: "00063076.00", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "TRXD", label: "TRXD", code: "00063015.00", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "WBOX", label: "W-BOX", code: "00049521.02", volume: "0.064", weight: "1.42", length: "64.5", width: "52.5", height: "19", image: WBox },
    { value: "F1", label: "F1", code: "00064352.01", volume: "0.102", weight: "2.55", length: "62.5", width: "58.5", height: "28" },
    { value: "F1+", label: "F1+", code: "00080108.00", volume: "0.144", weight: "2.9", length: "63", width: "58.5", height: "39" },
    { value: "F2", label: "F2", code: "00080109.00", volume: "0.173", weight: "3.2", length: "63", width: "58.5", height: "47" },
    { value: "F2+", label: "F2+", code: "00080110.00/64370.01", volume: "0.229", weight: "3.6", length: "63", width: "58.5", height: "62" },
    { value: "C495 with pallet", label: "C495 with pallet", code: "7344756.D", volume: "0.271", weight: "8.29", length: "76", width: "49.5", height: "72" },
    { value: "C870 with pallet", label: "C870 with pallet", code: "P343471.01", volume: "0.489", weight: "17", length: "87", width: "76", height: "74", image: C870 },
    { value: "S14", label: "S14", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S71", label: "S71", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S59", label: "S59", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S60", label: "S60", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S61", label: "S61", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S62", label: "S62", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S66", label: "S66", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S64", label: "S64", code: "", volume: "", weight: "", length: "", width: "", height: "" },
    { value: "S65", label: "S65", code: "", volume: "", weight: "", length: "", width: "", height: "" },
  ];

  useEffect(() => {
    // Set page title
    document.title = 'Outerbox Type Reference - Complete Catalog';

    // Generate barcodes using JsBarcode from CDN
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js';
    script.async = true;
    script.onload = () => {
      outerboxData.forEach(item => {
        if (item.code && barcodeRefs.current[item.code]) {
          try {
            window.JsBarcode(barcodeRefs.current[item.code], item.code, {
              format: "CODE128",
              width: 1.5,
              height: 50,
              displayValue: true,
              fontSize: 11,
              margin: 5,
              background: "#ffffff",
              lineColor: "#000000"
            });
          } catch (error) {
            console.error('Barcode generation error for', item.code, error);
          }
        }
      });
    };
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleCopySuccess = (code) => {
    setCopiedCode(code);
    // Reset the copied state after 2 seconds
    setTimeout(() => {
      setCopiedCode(null);
    }, 2000);
  };

  return (
    <div className="w-full p-4 sm:p-6 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-6">
            <h1 className="text-3xl sm:text-4xl font-bold text-black ml-6 mt-4">Outerbox Type Reference</h1>
            <p className="text-black mt-2 ml-6">Complete catalog with specifications and barcodes</p>
          </div>

          <div className="p-4 sm:p-6">
            <style>
              {`
                .copy-button {
                  transition: all 0.2s ease-in-out;
                }
                
                .copy-button:hover {
                  transform: scale(1.05);
                  background-color: #f8f9fa !important;
                  border-color: #007bff !important;
                }
              `}
            </style>
            
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="w-full border-collapse">
                <thead className='bg-blue-600 '>
                  <tr className="bg-blue-600 text-white">
                    <th className="border-b border-blue-500 px-3 py-4 text-left text-sm font-semibold">Code</th>
                    <th className="border-b border-blue-500 px-3 py-4 text-left text-sm font-semibold">Name</th>
                    <th className="border-b border-blue-500 px-3 py-4 text-left text-sm font-semibold">SKU</th>
                    <th className="border-b border-blue-500 px-3 py-4 text-center text-sm font-semibold">Barcode</th>
                    <th className="border-b border-blue-500 px-3 py-4 text-center text-sm font-semibold">Volume (m³)</th>
                    <th className="border-b border-blue-500 px-3 py-4 text-center text-sm font-semibold">Weight (kg)</th>
                    <th className="border-b border-blue-500 px-3 py-4 text-center text-sm font-semibold">L×W×H (cm)</th>
                  </tr>
                </thead>
                <tbody>
                  {outerboxData.map((item, index) => (
                    <tr
                      key={item.value}
                      className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 transition-colors`}
                    >
                      <td className="border-b border-gray-200 px-3 py-3">
                        <span className="font-bold text-blue-700 bg-blue-50 px-2 py-1 rounded">{item.value}</span>
                      </td>
                      <td className="border-b border-gray-200 px-3 py-3">
                        <div className="flex items-start justify-between gap-4">
                          <span className="font-medium text-gray-900 flex-shrink-0 min-w-0">
                            {item.label}
                          </span>
                          <div className="relative group flex-shrink-0">
                            {item?.image ? (
                              <img
                                src={item?.image}
                                alt={item.label}
                                height={100}
                                className="w-16 h-16 object-cover shadow-md cursor-pointer hover:shadow-xl transition-all duration-200 border-2 border-gray-200 hover:border-blue-400 rounded"
                              />
                            ) : (
                              <div className="w-16 h-16 flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 text-gray-400">
                                <ImageOff className="w-5 h-5 mb-1" />
                                <span className="text-xs text-center px-1">No Image</span>
                              </div>
                            )}
                            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all rounded flex items-center justify-center">
                              <ZoomIn className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="border-b border-gray-200 px-3 py-3">
                        {item.code ? (
                          <div className="flex items-center gap-2">
                            <code className="text-xs sm:text-sm bg-gray-100 px-2 py-1 rounded border border-gray-300 font-mono">{item.code}</code>
                            <CopyToClipboard 
                              text={item.code}
                              onCopy={() => {
                                handleCopySuccess(item.code);
                                console.log('Code copied to clipboard:', item.code);
                              }}
                            >
                              <button 
                                className="copy-button"
                                style={{
                                  background: copiedCode === item.code ? '#d4edda' : 'none',
                                  border: `1px solid ${copiedCode === item.code ? '#28a745' : '#ddd'}`,
                                  cursor: 'pointer',
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: copiedCode === item.code ? '#28a745' : '#007bff',
                                  fontSize: '12px',
                                  minWidth: '20px',
                                  height: '20px'
                                }}
                                title={copiedCode === item.code ? 'Copied!' : `Copy code: ${item.code}`}
                              >
                                <i className={copiedCode === item.code ? "fas fa-check" : "fas fa-copy"}></i>
                              </button>
                            </CopyToClipboard>
                          </div>
                        ) : (
                          <span className="text-gray-400 text-sm italic">N/A</span>
                        )}
                      </td>
                      <td className="border-b border-gray-200 px-3 py-3">
                        {item.code ? (
                          <div className="flex flex-col items-center gap-2">
                            <svg ref={el => barcodeRefs.current[item.code] = el} className="max-w-full"></svg>
                            <CopyToClipboard 
                              text={item.code}
                              onCopy={() => {
                                handleCopySuccess(item.code);
                                console.log('Barcode value copied to clipboard:', item.code);
                              }}
                            >
                              <button 
                                className="copy-button"
                                style={{
                                  background: copiedCode === item.code ? '#d4edda' : 'none',
                                  border: `1px solid ${copiedCode === item.code ? '#28a745' : '#ddd'}`,
                                  cursor: 'pointer',
                                  padding: '2px 6px',
                                  borderRadius: '3px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: copiedCode === item.code ? '#28a745' : '#007bff',
                                  fontSize: '12px',
                                  minWidth: 'auto',
                                  height: '20px',
                                  gap: '4px'
                                }}
                                title={copiedCode === item.code ? 'Copied!' : `Copy barcode value: ${item.code}`}
                              >
                                <i className={copiedCode === item.code ? "fas fa-check" : "fas fa-copy"}></i>
                                {/* {copiedCode === item.code ? (
                                  <span className="text-xs font-medium">Copied!</span>
                                ) : (
                                  <span className="text-xs">Copy</span>
                                )} */}
                              </button>
                            </CopyToClipboard>
                          </div>
                        ) : (
                          <span className="text-gray-400 text-sm italic">N/A</span>
                        )}
                      </td>
                      <td className="border-b border-gray-200 px-3 py-3 text-center font-medium">
                        {item.volume ? (
                          <span className="text-gray-700">{item.volume}</span>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>
                      <td className="border-b border-gray-200 px-3 py-3 text-center font-medium">
                        {item.weight ? (
                          <span className="text-gray-700">{item.weight}</span>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>
                      <td className="border-b border-gray-200 px-3 py-3 text-center font-mono text-sm">
                        {item.length && item.width && item.height ? (
                          <span className="text-gray-700">{item.length}×{item.width}×{item.height}</span>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-6 p-5 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 shadow-sm">
              <div className="flex items-start gap-3">
                <div className="text-sm text-gray-700 space-y-2">
                  <p>
                    <strong className="text-blue-700">Quick Guide:</strong>
                  </p>
                  <ul className="list-disc list-inside space-y-1 ml-2">
                    <li>Click the copy icon to copy any SKU code to your clipboard</li>
                    <li>Click on product images to view them in full size</li>
                    <li>Barcodes are generated in CODE128 format for scanning</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default OuterboxBarcodeTable;






































